<script setup lang="ts">
import { RouterLink, useRouter } from 'vue-router'
import { AppButton } from 'duanaga-ui'
import { useAuthStore } from '@/stores/auth'

const auth = useAuthStore()
const router = useRouter()
const appName = import.meta.env.VITE_APP_NAME ?? 'Code Generator'

const handleLogout = (): void => {
  auth.logout()
  router.push({ name: 'login' })
}
</script>

<template>
  <div class="min-h-screen bg-gradient-to-b from-grey-10 to-grey-20">
    <nav
      v-if="auth.isAuthenticated"
      class="border-b border-grey-20 bg-white/95 px-4 py-4 backdrop-blur-[6px]"
    >
      <div
        class="gap-3 mx-auto flex w-full max-w-[1200px] flex-col sm:flex-row sm:items-center sm:justify-between"
      >
        <div class="text-12 font-600 uppercase tracking-[0.1em] text-indigo-110">
          <RouterLink
            class="text-inherit no-underline"
            to="/batches"
          >
            {{ appName }}
          </RouterLink>
        </div>

        <div class="flex w-full items-center justify-between gap-4 sm:w-auto sm:justify-end">
          <AppButton
            text="Logout"
            color="light"
            icon="logout"
            outline
            class="text-red-60"
            @click="handleLogout"
          />
        </div>
      </div>
    </nav>

    <main class="flex min-h-[calc(100vh-64px)] justify-center px-4 py-16">
      <div class="w-full max-w-[1200px]">
        <slot />
      </div>
    </main>
  </div>
</template>
